import { productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { SupplierProduct } from "./supplier-product-types";

export const getProductSuppliers = {
  name: "getProductSuppliers" as const,
  input: z.object({ productId: productIdFormat.schema }),
  output: z.object({ supplierProducts: z.array(SupplierProduct) }),
};
